import { render } from "./KoruFieldValue.vue?vue&type=template&id=3dfb1e42&ts=true"
import script from "./KoruFieldValue.vue?vue&type=script&lang=ts"
export * from "./KoruFieldValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__